import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-table-data", () => {
    it("should render valid html", async () => {
        await testValidHtml(tableDataSortable());
    });
});

function tableDataSortable() {
    return `
    <ux-table-data name="example-table" full-width self-sorting>
  <ux-table-data-column-selection></ux-table-data-column-selection>
  <ux-table-data-column
    field="serial_number"
    label="Serial number"
    sortable
    group
  ></ux-table-data-column>
  <ux-table-data-column
    field="machine_id"
    label="Machine ID"
    sortable
    group
  ></ux-table-data-column>
  <ux-table-data-column-checkbox
    field="in_production"
    label="In Production"
    sortable
  ></ux-table-data-column-checkbox>
  <ux-table-data-column
    field="latest_maintenance_localized"
    label="Latest Maintenance"
    sortable
    sort-field="latest_maintenance_iso"
  ></ux-table-data-column>
</ux-table-data>
<script>
  const element = document.querySelector("ux-table-data");
  element.data = [
    { name: "TruMark", type: "Laser Machine", active: true },
    { name: "TruLaser", type: "Precision Machine", active: false },
  ];
  element.addEventListener("uxRowsSelected", function uxRowsSelected() {});
  element.addEventListener("uxRowClick", function uxRowClick() {});
</script>
    `;
}
